.container {
  position: relative;
}

.photoSwipeContainer {
  position: relative;
  width: 100%;
  height: 350px;
  border-radius: 3px;
  margin-top: -0.4rem;
  margin-bottom: 1rem;
  overflow-x: hidden;
  background: #222;
}

.actionButton {
  display: block;
  width: 100%;
  margin-top: "0.5rem !important";
  margin-bottom: "0.5rem !important";
}

.th {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.875rem;
  font-weight: 500 !important;
  padding: 0 !important;
}

.td {
  padding-left: 1rem;
}

.card {
  float: left;
  margin: 1rem 0;
  padding: 1.2rem;
  overflow: visible !important;
  border-color: rgba(0, 0, 0, 0.25);
  width: 100%;
}

.cardLabel {
  float: left;
  font-family: "InstrumentSans", "Arial", sans-serif;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  background: #fff;
  margin-top: -1.5rem;
  margin-left: -0.5rem;
  padding: 0 0.3rem;
}

.buttonsColumn {
  display: flex;
  align-items: center;
}

.buttons {
  width: 100%;
}

.list {
  list-style-type: square;
  padding: 0 0 0 1rem;
  font-size: 0.875rem;
}

.footnote {
  margin-top: 1rem;
}

.newTabLink {
  color: #000 !important;
  margin-left: 0.5rem;
}

.swiper {
  width: 100%;
  height: 100%;
}

.appendButtons {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */